import { RESULT_CODE } from "@/constants/enum";
import useAuth from "@/hooks/useAuth";
import { useLogoutMutation } from "@/services/authAPI";
import { Modal, Button, Image, Text, Flex } from "@mantine/core";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

type ModalSettingProps = {
  opened: boolean;
  close: () => void;
  img?: string;
  title?: string;
  description?: string;
  success?: boolean;
  descriptionExpired?: string;
  btn?: number; // 1 or 2
  countdown?: number;
  setCountdown?: (countdown: number) => void;
  isExpired?: boolean;
  setIsExpired?: (isExpired: boolean) => void;
};

const ModalSetting: React.FC<ModalSettingProps> = ({
  opened,
  close,
  img,
  title,
  description,
  success,
  descriptionExpired,
  btn,
  countdown,
  setCountdown,
  isExpired,
  setIsExpired,
}) => {
  const { t } = useTranslation();
  // const [, actionAuth] = useAuthentication();
  const { clearAuthState } = useAuth();

  // Countdown logic (optional)
  useEffect(() => {
    if (opened && countdown && countdown > 0 && setCountdown) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }

    if (countdown === 0 && setIsExpired) {
      setIsExpired(true);
    }
  }, [opened, countdown, setCountdown, setIsExpired]);

  const [logout] = useLogoutMutation();

  // Determine if expired mode should show
  const showExpired = opened && isExpired;
  const handleLogout = async () => {
    try {
      const response = await logout().unwrap();
      if (response.body.resultCode === RESULT_CODE.SUCCESS) {
        clearAuthState();
        close();
      }
      console.log({ response });
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };
  return (
    <Modal
      opened={opened}
      onClose={close}
      centered
      overlayProps={{ opacity: 0.6 }}
    >
      <Flex direction="column" align="center" justify="center" gap={10}>
        {img && <Image src={img} style={{ width: "148px", height: "148px" }} />}
        <Text sx={{ fontWeight: 700, fontSize: "18px", textAlign: "center" }}>
          {showExpired ? t("EXPIRED_REQUEST") : title}
        </Text>
        {showExpired && descriptionExpired && (
          <Text
            sx={{
              fontWeight: 400,
              fontSize: "14px",
              textAlign: "center",
              color: "#2E3337",
            }}
          >
            {descriptionExpired}
          </Text>
        )}
        {description && (
          <Text
            sx={{
              fontWeight: 400,
              fontSize: "14px",
              textAlign: "center",
              color: "#2E3337",
            }}
          >
            {description}
          </Text>
        )}

        <Flex w="100%" direction="column" gap={5} my={10}>
          {btn === 2 ? (
            <>
              <Button
                size="lg"
                sx={{ borderRadius: "8px", backgroundColor: "#2A81D0" }}
                w="100%"
                onClick={handleLogout}
              >
                {t("AGREE")}
              </Button>
              <Button
                size="lg"
                variant="subtle"
                sx={{ borderRadius: "8px", color: "#2A81D0" }}
                w="100%"
                onClick={close}
              >
                {t("CANCEL")}
              </Button>
            </>
          ) : (
            <Button
              size="lg"
              sx={{ borderRadius: "8px", backgroundColor: "#2A81D0" }}
              w="100%"
              onClick={success ? handleLogout : close}
            >
              {success ? t("BACK_TO_LOGIN") : t("I_GOT_IT")}
            </Button>
          )}
        </Flex>
      </Flex>
    </Modal>
  );
};

export default ModalSetting;
